"use strict";
// export const objToQueryString = (obj: any): string => {
//   // the object could be null
//   if (Object.keys(obj ?? {}).length === 0) {
//     return "";
//   }
Object.defineProperty(exports, "__esModule", { value: true });
exports.objToQueryString = void 0;
//   // also prepend the ?
//   return (
//     "?" +
//     Object.keys(obj)
//       .map((key) => key + "=" + obj[key])
//       .join("&")
//   );
// };
var objToQueryString = function (obj) {
    var _a, _b, _c;
    // the object could be null
    if (((_a = Object.keys(obj !== null && obj !== void 0 ? obj : {})) === null || _a === void 0 ? void 0 : _a.length) === 0) {
        return "";
    }
    // also prepend the ?
    return ("?" +
        ((_c = (_b = Object.keys(obj)) === null || _b === void 0 ? void 0 : _b.map(function (key) { return key + "=" + obj[key]; })) === null || _c === void 0 ? void 0 : _c.join("&")));
};
exports.objToQueryString = objToQueryString;
